import { Component, input } from '@angular/core';

@Component({
  selector: 'app-icon-apple-store',
  standalone: true,
  imports: [],
  templateUrl: './icon-apple-store.component.html',
  styleUrl: './icon-apple-store.component.scss',
})
export class IconAppleStoreComponent {
  isDarkMode = input<boolean>(false);
}
